var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRiteriaIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 22.7852H13.5",
    stroke: "#6A50FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8114 22.3445C10.1474 20.462 8.54991 17.1755 9.11241 13.5575C9.72141 9.64703 12.9809 6.52553 16.9124 6.06503C22.3694 5.42453 26.9999 9.67253 26.9999 15.0005C26.9999 18.038 25.4909 20.7185 23.1854 22.3475C22.7714 22.64 22.4999 23.093 22.4999 23.6V27.7505C22.4999 29.822 20.8214 31.5005 18.7499 31.5005H17.2499C15.1784 31.5005 13.4999 29.822 13.4999 27.7505V23.606C13.4999 23.0945 13.2269 22.6385 12.8114 22.3445Z",
    stroke: "#6A50FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30 7.49984L31.785 5.71484",
    stroke: "#6A50FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99984 22.5L4.21484 24.285",
    stroke: "#6A50FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49984 5.99984L5.71484 4.21484",
    stroke: "#6A50FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30 22.5L31.785 24.285",
    stroke: "#6A50FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 15H34.035",
    stroke: "#6A50FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1.96484 15H4.49984",
    stroke: "#6A50FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 27H22.305",
    stroke: "#6A50FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiteriaIcon3);
export default __webpack_public_path__ + "static/media/сriteria-icon-3.72886f4559c2abb65691fad4067afa6d.svg";
export { ForwardRef as ReactComponent };